import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { otpVerify } from "reduxStore/action/authActions";
import strings from "translate/language";
import { otpVerfiyValid, seo } from "utils/utils";

const Verifyotp = () => {
  const navigate = useNavigate();
  const forgotPasswordSelector =
    useSelector((state) => state.forgotPassword) || {};

  const [otpDetail, setOtpDetail] = useState({});
  const [errorMessage, setErrorMessage] = useState({});

  const dispatch = useDispatch();

  const otpVerification = async () => {
    const { response, verifyotp = false } = forgotPasswordSelector || {};
    if (response && verifyotp) {
      if (response?.status === 200) {
        navigate("/Resetpassword");
      }
    }
  };
  useEffect(() => {
    setOtpDetail({ ...otpDetail, email: forgotPasswordSelector.data.email });
  }, [forgotPasswordSelector]);
  useEffect(() => {
    otpVerification();
  }, [forgotPasswordSelector]);

  const validation = () => {
    let isError = true;
    let errorMessage = {};

    if (otpDetail.otp == undefined || otpDetail.otp == "") {
      isError = false;
      errorMessage["otp"] = strings.otpErr;
    } else if (!otpVerfiyValid(otpDetail.otp)) {
      isError = false;
      errorMessage["otp"] = strings.otpVerfiyValidErr;
    }
    setErrorMessage(errorMessage);
    return isError;
  };

  const Resetpassword = () => {
    if (validation()) {
      dispatch(otpVerify(otpDetail));
    }
  };
  useEffect(() => {
    seo({
      title: "OTP",
      metaDescription: "OTP",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <Fragment>
      <div className="page-wrapper">
        <div className="container-fluid p-0">
          {/* login page start*/}
          <div className="authentication-main">
            <div className="row">
              <div className="col-md-12">
                <div className="auth-innerright">
                  <div className="authentication-box">
                    <div className="text-center">
                      <img
                        className="login-logo"
                        src="/assets/images/JUSTOLOGO.jpg"
                        alt=""
                      />
                    </div>
                    <div className="card mt-4">
                      <div className="card-body">
                        <div className="text-center">
                          <h4>{strings.verifyOTP}</h4>
                          <h6>{strings.enterOTPRecivedOnEmail}</h6>
                        </div>
                        <form className="theme-form">
                          <div>
                            <label className="col-form-label pt-0">
                              {strings.enterOPT}
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              required=""
                              onChange={(e) =>
                                setOtpDetail({
                                  ...otpDetail,
                                  otp: e.target.value,
                                })
                              }
                            />
                            {errorMessage.otp && (
                              <span style={{ color: "red" }}>
                                {errorMessage.otp}
                              </span>
                            )}
                          </div>

                          <div
                            className="col-form-label pt-3 text-primary"
                            style={{ fontWeight: "bold" }}
                          >
                            <label>{strings.resendOTP}</label>
                          </div>
                          <div className="form-group form-row mt-2 mb-0">
                            <button
                              onClick={() => Resetpassword()}
                              className="btn btn-primary btn-block"
                              type="button"
                            >
                              {" "}
                              {strings.verify}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* login page end*/}
        </div>
      </div>
    </Fragment>
  );
};

export default Verifyotp;
